import { render, staticRenderFns } from "./YSLivePlayer.vue?vue&type=template&id=1d24353a&scoped=true"
import script from "./YSLivePlayer.vue?vue&type=script&lang=js"
export * from "./YSLivePlayer.vue?vue&type=script&lang=js"
import style0 from "../assets/css/Base.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d24353a",
  null
  
)

export default component.exports